import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Id } from 'Src/types/aliases'
import {
	CreateRealtyPatentModel,
	RealtyPatentModel,
	CreatePatent,
	UpdatePatent,
	DeletePatent,
} from 'Pages/registratorCabinet'

export type RealtyPatentsState = {
	realtyPatents: RealtyPatentModel[]
}

export const realtyPatentsInitialState: RealtyPatentsState = {
	realtyPatents: [],
}

export namespace RealtyPatentsNS {
	export type getRealtyPatents = PayloadAction<Id>
	export type createRealtyPatent = PayloadAction<CreatePatent<CreateRealtyPatentModel>>
	export type setRealtyPatents = PayloadAction<RealtyPatentModel[]>
	export type updateRealtyPatent = PayloadAction<UpdatePatent<CreateRealtyPatentModel>>
	export type clearRealtyPatents = PayloadAction
	export type deleteRealtyPatent = PayloadAction<DeletePatent>
}

export const realtyPatentsSlice = createSlice({
	name: 'realtyPatents',
	initialState: realtyPatentsInitialState,
	reducers: {
		getRealtyPatents: (state, action: RealtyPatentsNS.getRealtyPatents) => {},
		createRealtyPatent: (state, action: RealtyPatentsNS.createRealtyPatent) => {},
		setRealtyPatents: (state, action: RealtyPatentsNS.setRealtyPatents) => {
			state.realtyPatents = action.payload
		},
		updateRealtyPatent: (state, action: RealtyPatentsNS.updateRealtyPatent) => {},
		clearRealtyPatents: (state, action: RealtyPatentsNS.clearRealtyPatents) => {
			state.realtyPatents = []
		},
		deleteRealtyPatent: (state, action: RealtyPatentsNS.deleteRealtyPatent) => {},
	},
})
